import React,{useEffect,useContext,useState} from 'react';
import styles from './challengeBar.module.css'
import {Link} from 'react-router-dom'
import axios from 'axios'
import { UserContext } from '../../../context/userContext';


const Previous=()=>{

  const {user}=useContext(UserContext);
  const [challengeList,setChallengeList]=useState();

  const apiurl = "https://vsam.me/api/api.php?request=challengeList";

const getChallengeList=()=>{
  axios.post(apiurl,{
    "user_id":user.userid,"token":user.token,duration:"past"
}
).then(res=>{
    if(res.data.status===false){
    ////handle error
     }
     if(res.data.status===true){
    //  console.log(res.data)
    setChallengeList(res.data.data)
    

     }
 })

}   
    


useEffect(()=>{
  getChallengeList();
  return () => {
    setChallengeList()
  }
},[])



    return(
        <div>
 {challengeList?
   <>
                {challengeList.map(e=>
                <div key={e.Challenge_Id} className={styles.challengeHeading}>
                <Link to="/c/rock_n_roll_01">{e.Challange_Name}</Link>
                <div>Closed Participated {e.Users_Joined}</div>
               </div>)}</>:"Loading"}
          
                
        </div>
    )
}

export default Previous